export default "__VITE_ASSET__B_zUQ3zB__"